<template>
  <div>
    <button
      :title="title"
      @click="toggleModal"
      @keyup.enter="toggleModal"
      class="c-infobutton"
    >
      <slot />
    </button>
    <modal
      v-if="showModal"
      @close="toggleModal"
      class="c-modal--narrow"
    >
      <h2>{{ modal.title }}</h2>
      <div v-html="modal.description" />
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'InfoButton',
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      default: 'Klikk for mer info',
    }, 
    modal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;

      if (window.__selector_settings__.trackers.gaCheck === true) {
        const action = 'Infobutton: vis mer info om: ' + this.modal.title + ' (' + this.showModal + ')';
        this.$gtag.event(action, {
          event_category: 'Modal',
          event_label: 'calculator_show_hide_modal',
        });
      }
    },
  },
};
</script>
